// src/firebase.js
import { initializeApp } from 'firebase/app';
import { 
  getFirestore, 
  collection, 
  addDoc, 
  serverTimestamp 
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, logEvent } from 'firebase/analytics';

// 🧩 Configuración principal
const firebaseConfig = {
  apiKey: "AIzaSyDhbYqzth1TqMYIVdU-_1ZtRAc0IToEfFs",
  authDomain: "tarjeta-ad945.firebaseapp.com",
  databaseURL: "https://tarjeta-ad945-default-rtdb.firebaseio.com",
  projectId: "tarjeta-ad945",
  storageBucket: "tarjeta-ad945.appspot.com",
  messagingSenderId: "647226560983",
  appId: "1:647226560983:web:49de0148974d912db0fb92",
  measurementId: "G-3XBD5C1WMH",
};

const FIREBASE_REGION = 'us-central1';
const FUNCTIONS_BASE_URL = `https://${FIREBASE_REGION}-${firebaseConfig.projectId}.cloudfunctions.net`;
const getFunctionUrl = (name) => `${FUNCTIONS_BASE_URL}/${name}`;

// 🚀 Inicializar Firebase
const app = initializeApp(firebaseConfig);

// 🔥 Inicializar servicios
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, FIREBASE_REGION);

// 📊 Habilitar Analytics (solo en navegador)
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// ✅ Exportar módulos
export { 
  app, 
  db, 
  storage, 
  functions, 
  analytics, 
  logEvent, 
  collection, 
  addDoc, 
  serverTimestamp,
  firebaseConfig,
  FIREBASE_REGION,
  FUNCTIONS_BASE_URL,
  getFunctionUrl,
};
